import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import presentations from './modules/presentations';
import presenter from './modules/presenter';
import userApi from '../api/userApi';
import offlineStore from '../api/offlineStoreApi';
import desktopAppApi from '../api/desktopAppApi';

Vue.use(Vuex);
offlineStore.init();

const store = new Vuex.Store({
  strict: true,
  modules: {
    user,
    presentations,
    presenter
  }
});

userApi.init(store);
desktopAppApi.init(store);

offlineStore.getRecentPresentations().then((recentPresentations) => {
  if (recentPresentations) {
    store.dispatch('setAttendedPresentations', recentPresentations);
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js